/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { VolcanoContainer } from './events/data/VolcanoContainer';
import { VolcanoEventSearchPage } from './events/search/VolcanoEventSearchPage';
import { VolcanoLocContainer } from './locations/data/VolcanoLocContainer';
import { VolcanoLocSearchPage } from './locations/search/VolcanoLocSearchPage';
import { VolcanoEventEditPage } from './events/edit/VolcanoEventEditPage';
import { VolcanoLocationEditPage } from './locations/edit/VolcanoLocationEditPage';
import { VolcanoEventInfoPage } from './events/info/VolcanoEventInfoPage';
import { withUser } from '../../../auth/withUser';
import { isDataManager } from '../../../../role/roleUtils';


const VolcanoUnwrapped = ({ basePath, authorities }) => {
  const dataManager = isDataManager(authorities);

  return (
    <Switch>
      <Route exact path={`${basePath}/event-data`} component={withUser(VolcanoContainer)} />
      <Route exact path={`${basePath}/event-search`} component={VolcanoEventSearchPage} />
      <Route exact path={`${basePath}/loc-data`} component={withUser(VolcanoLocContainer)} />
      <Route exact path={`${basePath}/loc-search`} component={withUser(VolcanoLocSearchPage)} />
      { dataManager && <Route exact path={`${basePath}/event-update/:id`} render={props => (<VolcanoEventEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/event-update`} render={props => (<VolcanoEventEditPage {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/loc-update/:id`} render={props => (<VolcanoLocationEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/loc-update`} render={props => (<VolcanoLocationEditPage {...props} />)} />}
      <Route exact path={`${basePath}/event-more-info/:volcanoId`} component={withUser(VolcanoEventInfoPage)} />
      <Redirect to={`${basePath}/event-search`} />
    </Switch>
  );
};

VolcanoUnwrapped.propTypes = {
  basePath: PropTypes.string.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};

export const Volcano = withUser(VolcanoUnwrapped);
